export const headerHeightCls = cls`h-[52px] xl:h-[60px]`

export const paddingHeaderHeightCls = cls`pt-[52px] xl:pt-[60px]`

export const mainMarginTopIncludingHeaderCls = cls`mt-[-52px] xl:mt-[-60px]`
